import { useEffect, useRef } from 'react';

function useScrollToView() {
    const scrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        scrollRef.current?.scrollIntoView();
    }, []);

    return scrollRef;
}

export default useScrollToView;
